/**
 * A Global Event that support to pub/sub data between independent components
 ** dispatch - publish an event to another component
 ** on       - listen event which is sent from another component
 ** remove   - kill an event once component unmounts.
 * */
const EventBus = {
    $on(event, callback) {
        document.addEventListener(event, (e) => callback(e.detail));
    },

    $dispatch(event, data) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },

    $remove(event, callback) {
        document.removeEventListener(event, callback);
    },
};

export default EventBus;